export const BYTES_PER_MB = 1_048_576;

export const IMAGE_MAX_FILE_SIZE_MB = 10;
export const VIDEO_MAX_FILE_SIZE_MB = 100;
export const AUDIO_MAX_FILE_SIZE_MB = 20;
export const DOCUMENT_MAX_FILE_SIZE_MB = 20;
export const FONT_MAX_FILE_SIZE_MB = 5;
export const IMAGE_MAX_DIMENSION_PX = 4096;

/** Lower than other images because scanning an SVG for scripts costs several times its size in memory. */
export const SVG_MAX_FILE_SIZE_MB = 2;

/** The parser stops here. No type may exceed it, so it is the largest per-type limit. */
export const MAX_UPLOAD_FILE_SIZE_BYTES = VIDEO_MAX_FILE_SIZE_MB * BYTES_PER_MB;

export const UPLOAD_SIZE_LIMIT_MESSAGE = `File exceeds the maximum upload size of ${VIDEO_MAX_FILE_SIZE_MB} MB.`;

/** Frames multiply the decode cost, so an animation gets a tighter budget than one still image. */
export const MAX_STILL_PIXELS = IMAGE_MAX_DIMENSION_PX ** 2;
export const MAX_ANIMATED_PIXELS = 1280 * 720 * 9;

export const CLOUDINARY_API_TIMEOUT_MS = 10_000;

/** Past this, an upload gets a 503 and has to try again. Nothing queues. */
export const MAX_CONCURRENT_UPLOADS = Number(process.env.MCP_UPLOAD_CONCURRENCY) || 3;

/**
 * 512 MB fits the 1.5 GB staging pod, the smallest we run. The floor is two videos because each
 * upload reserves twice its size, and a lower budget could never admit the 100 MB we document.
 */
export const MAX_CONCURRENT_UPLOAD_BYTES =
  Math.max(Number(process.env.MCP_UPLOAD_BUDGET_MB) || 512, 2 * VIDEO_MAX_FILE_SIZE_MB) * BYTES_PER_MB;
